import type { AccountId, LocalisedCustomNames } from '../../shared-types'
import type {
  FormatRequestDataOptions,
  AccountSavePayload,
} from './formatRequestDataUtils'
import { buildRequestItem } from './formatRequestDataUtils'

const formatJsonRequestData = ({
  accounts,
  groups,
  groupMappedAccounts,
  mappedAccountIds,
  shouldUseOriginalNames,
  supportedLocales,
  recommendations,
}: FormatRequestDataOptions): Record<AccountId, AccountSavePayload> =>
  Object.keys(mappedAccountIds).reduce((acc, key) => {
    const groupId = mappedAccountIds[key]
    const mappedNumber = groupMappedAccounts[groupId][key].mappedNumber

    const account = buildRequestItem({
      id: key,
      mappedNumber,
      account: accounts[key],
      group: groups[groupId],
      shouldUseOriginalNames,
      supportedLocales,
      recommendation: recommendations?.[key],
    })

    return {
      ...acc,
      [key]: {
        ...account,
        ...supportedLocales.reduce(
          (acc, locale) => ({
            ...acc,
            [`customName${locale}`]: account[`name${locale}`],
          }),
          {} as Record<keyof LocalisedCustomNames, string>
        ),
      },
    }
  }, {} as Record<AccountId, AccountSavePayload>)

export default formatJsonRequestData
